import { CSSProperties, useEffect, useState } from 'react';
import { downloadFile } from '@vivli/shared/infrastructure/hook';
import { first } from 'rxjs/operators';
import { ButtonView } from '@vivli/shared/views';
import { useActiveUserContext, useAdminConsoleApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const buttonStyle: CSSProperties = {
    marginLeft: 0,
};

interface AuditTrailContextualProps {
    type: string;
    id: string;
    internalId: string;
}

export const AuditTrailContextualComponent = ({
    type,
    id, //protocolId, datar request DOI, etc.
    internalId, //id
}: AuditTrailContextualProps) => {
    const adminConsoleApiService = useAdminConsoleApiContext();
    const [auditExists, setAuditExists] = useState<boolean>(false);
    const modalService = useModalApiContext();
    const { user, hasPermission } = useActiveUserContext();
    //TODO PERMFE -replace to permissions+
    const isAuditAvailable = hasPermission(PermissionsEnum.DrActAdv);

    const handleError = (error: string) => {
        modalService.error(error);
    };

    const onDownload = () => {
        var fromDateRange = new Date(2023, 2, 1);
        var toDateRange = new Date();

        adminConsoleApiService
            .downloadAudit(fromDateRange, toDateRange, type, id, null)
            .pipe(first())
            .subscribe((data) => {
                downloadFile(
                    'data:application/json;charset=utf-8,' + encodeURIComponent(data.substr(1, data.length - 2)),
                    `auditTrail${Date.now().toString()}.json`
                );
            }, handleError);
    };

    useEffect(() => {
        if (isAuditAvailable) {
            adminConsoleApiService
                .getAuditPresence(type, internalId)
                .pipe(first())
                .subscribe((data) => {
                    setAuditExists(data);
                }, handleError);
        }
    }, [internalId]);

    if (!auditExists) {
        return null;
    }

    return (
        <ButtonView style={buttonStyle} onClick={onDownload} dataId={DTICommonConst.HeaderApprovalButton('DownloadAudit')}>
            Download Audit Trail
        </ButtonView>
    );
};
